const Regex = {
  phone: /^9\d{8}$/,
};

export default Regex;
